<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>LAYERED COMMUNICATION</div>
				<h2 waHeading="l" waText>Request/Response First, Real-Time When Ready</h2>
				<p waBody="m" waColorText="quiet" waText>REST and AJAX are the foundation. WebSocket is the upgrade path.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Communication Stack</div>
					<markdown [data]="mdContent_1170" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<p waBody="m" waText>The request/response layer is always present. REST endpoints, AJAX event handlers, and data services require no additional dependencies beyond JWebMP core. The real-time layer is opt-in &mdash; add it when your application needs push updates, live data, or bidirectional messaging.</p>
			</div>
		</div>
	</div>
</div>